<template>
  <v-app>
    <v-container>
      <v-row>
        <v-col cols="10" offset="1">
          <v-card class="pa-4" id="invoice-content">
            <v-row>
              <!-- <v-col cols="12">
                <v-card flat class="d-flex align-start justify-space-between" style="border-bottom: 2px solid #eee;">
                  <div>
                    <h4 class="text-uppercase font-weight-bold mb-1">{{ companyInfo.name }}</h4>
                    <div class="text-subtitle-2" style="width:70%; text-wrap: wrap;" v-html="companyInfo.address"></div>
                    <div class="text-subtitle-2"><span class="mdi mdi-phone-outline"></span> &nbsp; {{ companyInfo.mobile }}</div>
                    <div class="text-subtitle-2"><span class="mdi mdi-email-outline"></span> &nbsp; {{ companyInfo.email }}</div>
                    <div class="text-subtitle-2">{{ companyInfo.company_website }}</div>
                  </div>
                  <img :src="getCurrentCompany.logo_thumb ? getFileServerUrl + getCurrentCompany.logo_thumb : '@/assets/image/logo.png'" class="logo"/>
                </v-card>
              </v-col> -->
              <v-col cols="12">
                <h4 class="d-flex justify-center center" style="color: #333;"><strong>SALE INVOICE</strong></h4>
                <v-row class="justify-space-between">
                  <v-col cols="8">
                    <p style="color: #333;"><strong>BILL TO:</strong></p>
                    <p style="color: #555;" class="text-sub-2">{{ customer.company_name }}</p>
                    <p style="color: #555; width:32%; text-wrap: wrap;" class="text-sub-2">{{ customer.company_address }}</p>
                    <p style="color: #555;" class="text-sub-2"><strong>Contact No:</strong> {{ customer.company_mobile }}</p>
                  </v-col>
                  <v-col cols="4" class="text-right">
                    <h4 style="font-weight: normal; color: #333;"><strong>INVOICE # &nbsp;</strong>{{ code }}</h4>
                    <p style="color: #333;" class="text-sub-2"><strong>DATE &nbsp;</strong>{{ formatDateView(sale_order_date) }}</p>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" class="px-4">
                <br>
              </v-col>
            </v-row>
            <v-table class="mt-1" width="100%">
              <thead>
                <tr>
                  <th style="color: #333;">SN</th>
                  <th style="color: #333;">Code</th>
                  <th style="color: #333;">Item</th>
                  <th class="text-center" style="color: #333;">Quantity</th>
                  <th class="text-center" style="color: #333;">Unit</th>
                  <th class="text-center" style="color: #333;">Rate</th>
                  <th class="text-right" style="color: #333;">Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(product, key) in cart" :key="product.product_id">
                  <td style="color: #555;">{{ key + 1 }}</td>
                  <td style="color: #555;">{{ product.product_code }}</td>
                  <td style="color: #555;">{{ product.product_name }}</td>
                  <td class="text-center" style="color: #555;">{{ product.qty }}</td>
                  <td class="text-center" style="color: #555;">{{ product.unit_name }}</td>
                  <td class="text-center" style="color: #555;">{{ product.sale_rate }}</td>
                  <td class="text-right" style="color: #555;">{{ product.total }}</td>
                </tr>
                <v-divider></v-divider>
              </tbody>
            </v-table>
            <v-row class="py-10">
              <v-col cols="9">
                <p class="text-right" style="color: #555;">SUBTOTAL</p>
                <p class="text-right" style="color: #555;">DISCOUNT</p>
                <p class="text-right" style="color: #555;">VAT ({{ vat_type == 'excluded' ? 'Excluded' : 'Included' }})</p>
                <p class="text-right" style="color: #555;">TAX ({{ vat_type == 'excluded' ? 'Excluded' : 'Included' }})</p>
                <p class="text-right" style="color: #555;">TOTAL</p>
                <p class="text-right" style="color: #555;">PAID</p>
                <p class="text-right" style="color: #555;">DUE</p>
                <v-row class="font-weight-bold justify-space-between px-3 py-4">
                  <p colspan="3" style="color: #333;"><strong>{{ convertNumberToWords(total) }}</strong></p>
                </v-row>
              </v-col>
              <v-col cols="3">
                <p class="text-right" style="color: #555;">{{ subtotal ?? 0 }}</p>
                <p class="text-right" style="color: #555;">{{ discount_amount ?? 0 }}</p>
                <p class="text-right" style="color: #555;">{{ vat_amount ?? 0 }}</p>
                <p class="text-right" style="color: #555;">{{ tax_amount ?? 0}}</p>
                <p class="text-right" style="color: #555;">{{ total ?? 0 }}</p>
                <p class="text-right" style="color: #555;">{{ paid ?? 0}}</p>
                <p class="text-right" style="color: #555;">{{ due ?? 0 }}</p>
              </v-col>
            </v-row>
            <v-row class="py-5">
              <v-col cols="12">
                <p style="color: #555;">{{ payment_terms }}</p>
              </v-col>
            </v-row>
            <v-row class="pt-5">
              <v-col cols="4">
                <p style="border-top: 1px solid #555; width: 200px; margin: 0 auto; color: #333; text-align:center">
                  <span>Receiver's Signature</span>
                </p>
              </v-col>
              <v-col cols="4"></v-col>
              <v-col cols="4">
                <p style="border-top: 1px solid #555; width: 200px; margin: 0 auto; color: #333; text-align:center">
                  <span>Remex Ingredient Solution</span>
                </p>
              </v-col>
            </v-row>
            <v-row class="text-center mt-6">
              <v-col cols="12">
                <!-- <v-btn color="primary" class="mr-2" @click="showPrintPreview = true">
                  <v-icon left>mdi-eye</v-icon> Print Preview
                </v-btn> -->
                <v-btn color="primary" class="mr-2" @click="printInvoice">
                  <v-icon left>mdi-printer</v-icon> Print
                </v-btn>
                <!-- <v-btn color="success" :href="`${prefix}sales/make-so-invoice-pdf/${sale_order_master_id}`" target="_blank"> -->
                <v-btn color="success" @click="downloadInvoice(sale_order_master_id)">
                  <v-icon left>mdi-file-pdf-box</v-icon> Download
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>

      <!-- Print Preview Modal -->
      <!-- <v-dialog v-model="showPrintPreview" max-width="800">
        <v-card>
          <v-card-title class="headline">Print Preview</v-card-title>
          <v-card-text>
            <div class="print-preview-content">
              <v-col cols="12">
                <v-card flat class="d-flex align-start justify-space-between" style="border-bottom: 2px solid #eee;">
                  <div>
                    <h4 class="text-uppercase font-weight-bold mb-1">Remex Corporation Ltd.</h4>
                    <div class="text-subtitle-2">Red Crescent Concord Tower 17, Unit 10/B</div>
                    <div class="text-subtitle-2">Mohakhali C/A, Dhaka-1212, Bangladesh</div>
                    <div class="text-subtitle-2">📞 +88-02222288648, +88-02222289278</div>
                    <div class="text-subtitle-2">✉️ info@remexcorp.com</div>
                    <div class="text-subtitle-2">www.remexcorp.com</div>
                  </div>
                  <img :src="getCurrentCompany.logo_thumb ? getFileServerUrl + getCurrentCompany.logo_thumb : '@/assets/image/logo.png'" class="logo"/>
                </v-card>
              </v-col>
              <v-col cols="12">
                <h4 class="d-flex justify-center center"><strong>Invoice</strong></h4>
                <v-row class="justify-space-between">
                  <v-col cols="8">
                    <p><strong>BILL TO:</strong></p>
                    <p>Quality Mineral Industriesk</p>
                    <p>40, Haider Box Lane, Urdu Road, Dhaka-1211, Bangladesh</p>
                    <p><strong>Attention:</strong> Md. Faruk</p>
                    <p><strong>Contact No:</strong> 01714-223707</p>
                  </v-col>
                  <v-col cols="4" class="text-right">
                    <h4><strong>INVOICE # SO001</strong></h4>
                    <p><strong>DATE 2025-10-12</strong></p>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" class="px-4">
                <br>
              </v-col>
              <v-table class="mt-1" width="100%">
                <thead>
                  <tr>
                    <th>SN</th>
                    <th>Code</th>
                    <th>Item</th>
                    <th class="text-center">Quantity</th>
                    <th class="text-center">Unit</th>
                    <th class="text-center">Rate</th>
                    <th class="text-center">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>pro002</td>
                    <td>Polyglycerol Polyricinoleate (PGPR)</td>
                    <td class="text-center">1</td>
                    <td class="text-center">Pound</td>
                    <td class="text-center">60</td>
                    <td class="text-right">60</td>
                  </tr>
                  <v-divider></v-divider>
                </tbody>
              </v-table>
              <v-row class="py-10">
                <v-col cols="9">
                  <p class="text-right">SUBTOTAL</p>
                  <p class="text-right">DISCOUNT (0.00%)</p>
                  <p class="text-right">VAT (0.00%) Excluded</p>
                  <p class="text-right">TAX (0.00%) Excluded</p>
                  <p class="text-right"><strong>TOTAL</strong></p>
                  <p class="text-right"><strong>PAID</strong></p>
                  <p class="text-right"><strong>DUE</strong></p>
                  <v-row class="font-weight-bold justify-space-between px-3 py-4">
                    <p colspan="3"><strong>IN WORD: SIXTY ONLY.</strong></p>
                  </v-row>
                </v-col>
                <v-col cols="3">
                  <p class="text-right font-weight-bold">60</p>
                  <p class="text-right font-weight-bold">0.00</p>
                  <p class="text-right font-weight-bold">0.00</p>
                  <p class="text-right font-weight-bold">0.00</p>
                  <p class="text-right font-weight-bold">60</p>
                  <p class="text-right font-weight-bold">0</p>
                  <p class="text-right font-weight-bold">60</p>
                </v-col>
              </v-row>
              <v-row class="px-4">
                <p>Received the Above goods in actual weight and good condition</p>
              </v-row>
              <v-row class="px-4">
                <p><strong>Receiver's Signature _________________________</strong></p>
                <p><strong>Remex Ingredient Solution</strong></p>
              </v-row>
              <v-row class="text-center mt-6">
                <p class="text-caption">Page 1 of 1</p>
              </v-row>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="printInvoice">Print</v-btn>
            <v-btn color="secondary" @click="showPrintPreview = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog> -->
    </v-container>
  </v-app>
</template>

<script>
import convertNumberToWords from "@/plugins/numberToWord";
import formatDateView from "@/plugins/dateFormatView";
import { prefix } from "@/store/api";
import Axios from "axios";
export default {
  data() {
    return {
      showPrintPreview: false,
      sale_order_master_id: '',
      code: '',
      sale_order_date: '',
      delivery_address: '',
      description: '',
      previous_due: '',
      due: '',
      paid: '',
      payment_terms: '',
      ref_no: '',
      discount_amount: '',
      tax_type: '',
      tax_amount: '',
      vat_type: '',
      vat_amount: '',
      sub_total: '',
      total: '',
      companyInfo: {
        name: "Remex Corporation Ltd.",
        mobile: "+88-02222288648, +88-02222289278",
        address: "Red Crescent Concord Tower 17, Unit 10/B, Mohakhali C/A, Dhaka-1212, Bangladesh",
        email: "info@remexcorp.com",
        code: '',
        bin_no: '',
        tin_no: '',
        group_head_ind: '',
        logo: '',
        logo_thumb: '',
        website: ''
      },
      customer: {
        company_name: '',
        code: '',
        company_owner_name: '',
        company_mobile: '',
        company_email: '',
        company_address: '',
      },
      cart: [],
      prefix: prefix
    };
  },
  methods: {
    convertNumberToWords,
    
    formatDateView,

    async downloadInvoice(id) {
      // const token = localStorage.getItem("token");
      try {
        const response = await Axios.get(`${prefix}sales/make-so-invoice-pdf/${id}`, {
          responseType: "blob",
          // headers: {
          //   Authorization: `Bearer ${token}`,
          // },
        });

        // Create URL and trigger download
        const url = window.URL.createObjectURL(new Blob([response.data]));
        // window.open(url, "_blank");
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `invoice-${id}.pdf`);
        document.body.appendChild(link);
        link.click();
      } catch (error) {
        console.error("Download failed:", error);
      }
    },
    async printInvoice() {
      // const printContent = document.querySelector('#invoice-content').innerHTML;
      // const originalContent = document.body.innerHTML;
      // document.body.innerHTML = `
      //   <div class="print-content">${printContent}</div>
      // `;
      // window.print();
      // document.body.innerHTML = originalContent;

      // return;
    
      // Use Option 1 (document.write) - RECOMMENDED
      // const printContent = document.getElementById('invoice-content').innerHTML;
      // const addressLines = this.companyInfo.address.split('\n').filter(line => line.trim());
      // ${addressLines.map(line => `<p>${line}</p>`).join('')}
      //  .table>:not(caption)>*>* {
      //                 background-color: unset;
      //               }
      let printWindow = window.open('', 'PRINT', `width=${screen.width}, height=${screen.height}, left=0, top=0`);
      printWindow.document.write(`
                <!DOCTYPE html>
                <html>
                <head>
                  <meta charset="UTF-8">
                  <meta name="viewport" content="width=device-width, initial-scale=1.0">
                  <meta http-equiv="X-UA-Compatible" content="ie=edge">
                  <title>Invoice</title>
                  <link rel="preconnect" href="https://fonts.googleapis.com">
                  <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
                  <link href="https://fonts.googleapis.com/css2?family=Arimo:ital,wght@0,400..700;1,400..700&display=swap" rel="stylesheet">
                  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.8/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-sRIl4kxILFvY47J16cr9ZwB07vP4J8+LH7qKQnuqkuIAvNWLzeN8tE5YBujZqJLB" crossorigin="anonymous">
                  <link href="https://cdn.jsdelivr.net/npm/@mdi/font@7.4.47/css/materialdesignicons.min.css" rel="stylesheet">
                  <style>
                    body {
                      font-family: 'Arimo', sans-serif;
                      margin: 0px;
                    }
                    .invoice-header {
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                      border-bottom: 2px solid #eee;
                      padding-bottom: 10px;
                    }
                    .invoice-header img {
                      max-height: 70px;
                      max-width: 150px;
                    }
                    .table th, .table td {
                      border: 1px solid #000;
                      padding: 8px;
                      vertical-align: middle;
                    }
                    .table th {
                      background-color: #f0f0f0;
                      color: #333;
                    }
                    .table td {
                      background-color: unset;
                    }
                    .text-end {
                      text-align: right;
                    }
                    .text-center {
                      text-align: center;
                    }
                    h4 {
                      font-size: 20px;
                      color: #333;
                    }
                    p {
                      font-size: 14px;
                      color: #555;
                      margin: 2px 0;
                    }
                    strong {
                      font-weight: bold;
                      color: #333;
                    }
                    .signature-line {
                      border-top: 1px solid #555;
                      width: 200px;
                      margin: 0 auto;
                      text-align: center;
                      color: #333;
                    }
                    @page {
                      margin: 0.5in;
                      size: letter;
                    }
                    .logo-container {
                      display: flex;
                      align-items: center;
                    }
                    .logo-container img {
                      margin-right: 10px;
                    }
                    .watermark {
                      position: absolute;
                      top: 50%;
                      left: 50%;
                      transform: translate(-50%, -50%);
                      background-image: url('${this.getCurrentCompany.logo_thumb ? this.getFileServerUrl + this.getCurrentCompany.logo_thumb : '@/assets/image/logo.png'}');
                      background-repeat: no-repeat;
                      background-position: center;
                      background-size: contain;
                      width: 80%; 
                      height: 80%;
                      opacity: 0.1;
                      z-index: -1;
                      pointer-events: none;
                    }
                  </style>
                </head>
                <body>
                  <div class="container-fluid position-relative">
                    <div class="watermark"></div>
                    <div class="invoice-header">
                      <div>
                        <h4 class="text-uppercase">${this.getCurrentCompany.name}</h4>
                        <p style="width:65%">${this.getCurrentCompany.address}</p>
                        <p><i class="mdi mdi-phone-outline"></i> ${this.getCurrentCompany.mobile}</p>
                        <p><i class="mdi mdi-email-outline"></i> ${this.getCurrentCompany.email}</p>
                        ${this.getCurrentCompany?.website ? `<p><i class="mdi mdi-web"></i> ${this.getCurrentCompany.website}</p>` : ''}
                      </div>
                      <div class="logo-container">
                        <img src="${this.getCurrentCompany.logo_thumb ? this.getFileServerUrl + this.getCurrentCompany.logo_thumb : '@/assets/image/logo.png'}" alt="Logo" class="img-fluid">
                      </div>
                    </div>
                    <h4 class="text-center my-4"><strong>INVOICE</strong></h4>
                    <div class="row">
                      <div class="col-sm-8">
                        <p><strong>BILL TO:</strong></p>
                        <p class="text-sub-2">${this.customer.company_name}</p>
                        <p class="text-sub-2" style="width:65%" text-wrap: wrap;">${this.customer.company_address}</p>
                        <p class="text-sub-2"><strong>Contact No:</strong> ${this.customer.company_mobile}</p>
                      </div>
                      <div class="col-sm-4 text-end">
                        <h4><strong>INVOICE # ${this.code}</strong></h4>
                        <p class="text-sub-2"><strong>DATE ${this.formatDateView(this.sale_order_date)}</strong></p>
                      </div>
                    </div>
                    <table class="table mt-4">
                      <thead>
                        <tr>
                          <th>SN</th>
                          <th>Code</th>
                          <th>Item</th>
                          <th class="text-center">Quantity</th>
                          <th class="text-center">Unit</th>
                          <th class="text-end">Rate</th>
                          <th class="text-end">Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        ${this.cart.map((product, key) => `
                          <tr>
                            <td>${key + 1}</td>
                            <td>${product.product_code}</td>
                            <td>${product.product_name}</td>
                            <td class="text-center">${product.qty}</td>
                            <td class="text-center">${product.unit_name}</td>
                            <td class="text-end">${product.sale_rate}</td>
                            <td class="text-end">${product.total}</td>
                          </tr>
                        `).join('')}
                      </tbody>
                    </table>
                    <div class="row py-4">
                      <div class="col-sm-8">
                        <p class="text-end">SUBTOTAL</p>
                        <p class="text-end">DISCOUNT</p>
                        <p class="text-end">VAT (${this.vat_type == 'excluded' ? 'Excluded' : 'Included'})</p>
                        <p class="text-end">TAX (${this.vat_type == 'excluded' ? 'Excluded' : 'Included'})</p>
                        <p class="text-end">TOTAL</p>
                        <p class="text-end">PAID</p>
                        <p class="text-end">DUE</p>
                        <p class="text-start"><strong>${this.convertNumberToWords(this.total)}</strong></p>
                      </div>
                      <div class="col-sm-4 text-end">
                        <p><strong>${this.subtotal ?? 0}</strong></p>
                        <p><strong>${this.discount_amount ?? 0}</strong></p>
                        <p><strong>${this.vat_amount ?? 0}</strong></p>
                        <p><strong>${this.tax_amount ?? 0}</strong></p>
                        <p><strong>${this.total ?? 0}</strong></p>
                        <p><strong>${this.paid ?? 0}</strong></p>
                        <p><strong>${this.due ?? 0}</strong></p>
                      </div>
                    </div>
                    <div class="row py-3">
                      <div class="col-sm-12">
                        <p>${this.payment_terms}</p>
                      </div>
                    </div>
                    <div class="row pt-4">
                      <div class="col-sm-4 text-center">
                        <p class="signature-line">Receiver's Signature</p>
                      </div>
                      <div class="col-sm-4"></div>
                      <div class="col-sm-4 text-center">
                        <p class="signature-line">Remex Ingredient Solution</p>
                      </div>
                    </div>
                  </div>
                </body>
                </html>
              `);
      // printWindow.document.close();
      printWindow.moveTo(0, 0);
      printWindow.focus();
      await new Promise(resolve => setTimeout(resolve, 1000));
      printWindow.print();
      printWindow.close();
    }
  },
  computed: {
    getCurrentCompany() {
      this.companyInfo = this.$store.getters.getCurrentCompany;
      return this.$store.getters.getCurrentCompany;
    },
    getFileServerUrl() {
      return this.$store.getters.getFileServerUrl;
    },
  },
  mounted() {
    const id = this.$route.params.id;
    if (id) {
      this.$nextTick(() => {
        this.$store
          .dispatch("getSaleInvoiceById", id)
          .then((data) => {
              let saleInvoice = data;
              this.sale_order_master_id = saleInvoice.id
              this.code = saleInvoice.code
              this.sale_order_date = saleInvoice.sale_order_date
              this.delivery_address = saleInvoice.delivery_address
              this.description = saleInvoice.description
              this.previous_due = saleInvoice.previous_due
              this.due = saleInvoice.due
              this.paid = saleInvoice.paid
              this.payment_terms = saleInvoice.sale_order.payment_terms
              this.ref_no = saleInvoice.ref_no
              this.discount_amount = saleInvoice.discount_amount
              this.tax_type = saleInvoice.tax_type
              this.tax_amount = saleInvoice.tax_amount
              this.vat_type = saleInvoice.vat_type
              this.vat_amount = saleInvoice.vat_amount
              this.sub_total = saleInvoice.sub_total
              this.total = saleInvoice.total

              this.customer = {
                company_name: saleInvoice.customer?.company_name || "",
                code: saleInvoice.customer?.code || "",
                company_owner_name: saleInvoice.customer?.company_owner_name || "",
                company_mobile: saleInvoice.customer?.company_mobile || "",
                company_email: saleInvoice.customer?.company_email || "",
                company_address: saleInvoice.customer?.company_address || "",
                logo: saleInvoice.customer?.logo || "",
                logo_thumb: saleInvoice.customer?.logo_thumb || "",
                company_website: saleInvoice.customer?.company_website || ""
              };

              this.cart = [];
              (saleInvoice.details || []).forEach((item) => {
                  this.cart.push({
                    product_id: item.product_id,
                    product_name: item.product?.name || "",
                    product_code: item.product.code || "",
                    qty: item.qty,
                    unit_id: item.product.unit_id || "",
                    unit_name: item.product.unit?.name || "",
                    purchase_rate: item.purchase_rate,
                    sale_rate: item.sale_rate,
                    total: item.total,
                  });
              });
              // this.remarks.value.value = saleInvoice.remarks ? saleInvoice.remarks : "";
              // this.companyInfo = [];
              // this.companyInfo = this.$store.getters.getCurrentCompany;
              // console.log(this.companyInfo)
          })

          .catch((error) => {
            console.error("Failed to fetch sale order:", error);
          });
      });
    }
  }
};
</script>

<style scoped>
@media print {
  body * {
    visibility: hidden;
  }
  .v-col.cols-10.offset-1, .v-col.cols-10.offset-1 * {
    visibility: visible;
  }
  .v-btn {
    display: none;
  }
  .v-card {
    border: none !important;
    box-shadow: none !important;
  }
  .v-table {
    width: 100% !important;
    border-collapse: collapse;
  }
  .v-table th, .v-table td {
    border: 1px solid #000;
    padding: 8px;
    text-align: left;
  }
  .v-table th {
    background-color: #f5f5f5;
  }
  .text-right {
    text-align: right !important;
  }
  .text-center {
    text-align: center !important;
  }
  @page {
    margin: 0.5in;
    size: letter;
  }
  .v-col.cols-10.offset-1 {
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
  }
  h4 {
    font-size: 20px !important;
  }
  p {
    font-size: 14px !important;
  }
  strong {
    font-weight: bold;
  }
}
.logo {
  margin: 0 0 auto;
}
.text-subtitle-2 {
  color: #555 !important;
}
.text-sub-2 {
  font-size: 14px !important;
}
.print-preview-content {
  padding: 20px;
  background-color: #fff;
  border: 1px solid #ccc;
}
/* @import url('https://fonts.googleapis.com/css2?family=Arimo&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Material+Icons+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200'); */
</style>